import { apiEndpoints } from "@/services/api/api";
import { LoaderFunction } from "react-router-dom";
import {AdminPanelDashboardLoaderData} from "@/routes/adminPanel/dashboard/types/adminPanelDashboardLoaderData.ts";

export const adminPanelDashboardLoader: LoaderFunction =
    async (): Promise<AdminPanelDashboardLoaderData> => {
        const response = await apiEndpoints.getAdminDashboardData();
        return response.data;
    };
